/**
 * User requirements to gate feature access.
 */
enum CreationToolUserRestriction {
    // user types
    Everyone = 'CT_USER_RESTRICTION_EVERYONE',
    StaffOnly = 'CT_USER_RESTRICTION_STAFF_ONLY',
    VerifiedOnly = 'CT_USER_RESTRICTION_VERIFIED_ONLY',
    LoggedInOnly = 'CT_USER_RESTRICTION_LOGGED_IN_ONLY',

    // permissions
    CanRate = 'CT_USER_RESTRICTION_CAN_RATE',
    CanRateVideo = 'CT_USER_RESTRICTION_CAN_RATE_VIDEO',
    CanUploadVideo = 'CT_USER_RESTRICTION_CAN_UPLOAD_VIDEO',
    CanAccessSuperCut = 'CT_USER_RESTRICTION_CAN_ACCESS_SUPER_CUT',
    CanAccessCollections = 'CT_USER_RESTRICTION_CAN_ACCESS_COLLECTIONS',
}

namespace CreationToolUserRestriction {
    /**
     * Returns all of the user restrictions.
     */
    export function all(): CreationToolUserRestriction[] {
        return Object.keys(CreationToolUserRestriction)
            .map(key => CreationToolUserRestriction[key])
            .filter(restriction => typeof restriction === 'string')
    }

    /**
     * Returns the user permission object key to check if the restriction has one.
     */
    export function permissionKeys(restriction: CreationToolUserRestriction): string[] {
        switch (restriction) {
            case CreationToolUserRestriction.CanRate:
                return ['rate']
            case CreationToolUserRestriction.CanRateVideo:
                return ['rate_upload_videos']
            case CreationToolUserRestriction.CanUploadVideo:
                return ['upload_videos']
            case CreationToolUserRestriction.CanAccessSuperCut:
                return ['access_dvr']
            case CreationToolUserRestriction.CanAccessCollections:
                return ['curate_all_channels', 'curate_own_subchannels']
            default:
                return []
        }
    }

    /**
     * Returns whether or not the user has access to this restriction.
     */
    export function hasAccess(
        restriction: CreationToolUserRestriction,
        userAccess: CreationToolUserRestriction[]
    ): boolean {
        return userAccess.indexOf(restriction) > -1
    }
}

export default CreationToolUserRestriction
